import axiosHttp from "./interceptor.service";

const getTimeTracking = (date, userId) => {
  return axiosHttp.post("/lmt/tenMinStatsAllUsers", { date, userId }); // Include userId
};

const addNotes = (id, note) => {
  return axiosHttp.put(`/lmt/addNotes/${id}`, { note });
};

const deleteTenMinStats = (data) => {
  return axiosHttp.post("/lmt/deleteTenMinStats", data);
};

const getMasterTableData = (date) => {
  return axiosHttp.post("/lmt/getMasterTableData", { date });
};

// time_logger DB endpoints
const getActivityDayView = (date, userId) => {
  return axiosHttp.post("/lmt/timeLogger/day-view", { date, userId });
};

const getActivitySummary = (from, to, userId) => {
  return axiosHttp.post("/lmt/timeLogger/summary", { from, to, userId });
};

const getActivityNotes = (date, userId) => {
  return axiosHttp.post("/lmt/timeLogger/notes", { date, userId });
};

const saveActivityNote = (payload) => {
  return axiosHttp.post("/lmt/timeLogger/saveNote", payload);
};

// Note approvals — every slot note on a date that a manager/admin can act on.
// status = "pending" | "approved" | "rejected" | "all".
// from/to are encrypted YYYY-MM-DD; the range is inclusive and capped at 92 days
// server-side. status travels in the clear.
const getNoteApprovals = (from, to, status) => {
  return axiosHttp.post("/lmt/timeLogger/noteApprovals", { from, to, status });
};

// action = "approve" | "reject". Approving credits the slot's missing minutes
// (10 - already tracked) so the day view counts them as worked time.
const reviewActivityNote = (payload) => {
  return axiosHttp.post("/lmt/timeLogger/reviewNote", payload);
};

const getActivityMasterList = (date) => {
  return axiosHttp.post("/lmt/timeLogger/masterList", { date });
};

// Productivity feature — list the org's domain → productivity map, and upsert an override.
const getDomainCategories = (userId) => {
  return axiosHttp.post("/lmt/timeLogger/domain-categories", { userId });
};

// type = "domain" | "app"; name = the website domain or app name.
const saveDomainCategory = (userId, type, name, productivity) => {
  return axiosHttp.post("/lmt/timeLogger/domain-category", { userId, type, name, productivity });
};

// Short-lived token that lets the admin connect to the Time-Logger signaling
// server and watch a user's screen live (WebRTC). The video itself never comes
// through here — this only authorises the realtime connection.
// targetUserId = the user about to be watched. Required for an Org Admin (the
// token is pinned to that one user); ignored for admin/manager.
const getLiveStreamToken = (targetUserId) => {
  return axiosHttp.get("/lmt/timeLogger/live-token", { params: { targetUserId } });
};

export {
  getTimeTracking,
  addNotes,
  deleteTenMinStats,
  getMasterTableData,
  getActivityDayView,
  getActivitySummary,
  getActivityNotes,
  saveActivityNote,
  getNoteApprovals,
  reviewActivityNote,
  getActivityMasterList,
  getLiveStreamToken,
  getDomainCategories,
  saveDomainCategory,
};
